import type { RendererOption } from './project-response-renderer.type';

export function reorderOptionsForMultipleChoice<
  T extends { value: string; label: string },
>(options: T[], type: RendererOption): T[] {
  if (!options?.length || type !== 'multipleChoice') return options ?? [];

  const otherIndex = options.findIndex((o) => o.value.includes('other'));
  if (otherIndex === -1 || otherIndex === options.length - 1) return options;

  return [
    ...options.slice(0, otherIndex),
    ...options.slice(otherIndex + 1),
    options[otherIndex],
  ];
}
